import PropTypes from "prop-types"
import { intComma } from "humanize-plus"

const UsersConnected = ({ usersTotal }) => (
  <div className="stat-box users-connected">
    <h3>Connected users</h3>
    <p className="stat">{intComma(usersTotal)}</p>
  </div>
)

UsersConnected.propTypes = {
  usersTotal: PropTypes.number.isRequired,
}

export default UsersConnected
